
    <div class="selected" (click)="showCoins = !showCoins">
      <span class="icon coin coin-{{ value }}"></span> <span class="text">{{ getLabelByKey(value) }}</span>
      <span class="arrow"><i class="fas fa-chevron-down"></i></span>
    </div>
    <div class="options" *ngIf="showCoins">
      <ng-container *ngFor="let coin of list">
        <div class="option" *ngIf="coin.value !== value" (click)="value = coin.value; showCoins = false">
          <span class="icon coin coin-{{ coin.value }}"></span> <span class="text">{{ coin.text.toUpperCase() }}</span>
        </div>
      </ng-container>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/currency-selector.component.ts.CurrencySelectorComponent.html